/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import IncorrectPenaltySection from "../../../../../components/Sections/Traffic/IncorrectPenaltySection/IncorrectPenaltySection";
import TrafficCheckin from "../../../../../components/Checkin/TrafficCheckin/TrafficCheckin";
import Container from "../../../../../components/Container/Container";
import TrafficCostRiskSection from "../../../../../components/Sections/Traffic/TrafficCostRiskSection/TrafficCostRiskSection";
import { getLastPathSplit } from "../../../../../services/redirect";
import { landingPagesList } from "../../../../../services/landingPagesList";
import Layout from "../../../../Layouts/Layout";
import LpTrafficOtherMeta from "./LpTrafficOtherMeta";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import { trafficTeaserCards } from "../../../../../services/landingPageService";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import HowItWorksSectionTraffic
  from "../../../../../components/Sections/Traffic/HowItWorksSection/HowItWorksSectioTraffic";

const LpTrafficOther = () => {
  const accusationData = {
    name: "other",
    detail: {
      name: "accusationOther",
      label: "Vorwurf auswählen",
      options: [
        { value: "mobile_phone", label: "Handyverstoß" },
        { value: "drugs", label: "Alkohol-/Drogenverstoß" },
        { value: "parking", label: "Parkverstoß" },
        { value: "other", label: "Anderer Tatvorwurf" },
      ],
    },
  };

  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Bußgeldbescheid & Fahrverbot";
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Kostenlose Ersteinschätzung bei Bußgeldbescheid!";
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpTrafficOtherMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Jetzt effektiv gegen Bußgeld, Punkte oder Fahrverbot vorgehen"}
        teaserButtonText={"Kostenlose Ersteinschätzung"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <TrafficCheckin
              idPrefix={"top"}
              checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung! Was wird Ihnen vorgeworfen?"}
              accusation={accusationData}
            />
          </Container>
        )}
        <IncorrectPenaltySection />
        <HowItWorksSectionTraffic />
      </GreyBackgroundWrapper>
      <TrafficCostRiskSection />
      <GreyBackgroundWrapper>
        <AttorneySection
          product={"traffic"}
          textCards={false}
          subheading={"Sie möchten professionell und unkompliziert gegen Ihren Bescheid vorgehen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        />
        <AdvantagesLegalbirdAttorneySection product={"traffic"} />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <TrafficCheckin
            idPrefix={"bottom"}
            checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung! Was wird Ihnen vorgeworfen?"}
            accusation={accusationData}
          />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
};

export default LpTrafficOther;
